// supabase/functions/_shared/booking/zoneLabel.ts
// What a prospect reads for a zone (spec booking §2, §5): the city, not the IANA id. « heure de Toronto »,
// « heure d'Edmonton », "Toronto time"; UTC stays « heure UTC » / "UTC". One source for the booking pages
// (src/components/gavion/booking/public/slotGroups.ts) and the reminder email (reminderEmail.ts).
// Final review M6: odd city ids read naturally (« St. John's », not « St Johns »); Etc/GMT±n reads « heure UTC∓n »
// (the IANA sign is inverted: Etc/GMT+5 is five hours behind UTC).

const UTC_IDS = new Set([
  "UTC",
  "UCT",
  "GMT",
  "Universal",
  "Zulu",
  "Greenwich",
  "Etc/UTC",
  "Etc/UCT",
  "Etc/GMT",
  "Etc/GMT0",
  "Etc/GMT+0",
  "Etc/GMT-0",
  "Etc/Universal",
  "Etc/Zulu",
  "Etc/Greenwich",
  "GMT0",
  "GMT+0",
  "GMT-0",
]);
const CITY_NAMES: Record<string, string> = {
  St_Johns: "St. John's",
  DumontDUrville: "Dumont d'Urville",
};

const utcLabel = (offset: string, lang: "fr" | "en"): string =>
  lang === "fr" ? `heure UTC${offset}` : `UTC${offset}`;

export function zoneLabel(tz: string, lang: "fr" | "en"): string {
  if (UTC_IDS.has(tz)) return utcLabel("", lang);
  const etc = /^Etc\/GMT([+-])(\d{1,2})$/.exec(tz);
  if (etc)
    return utcLabel(`${etc[1] === "+" ? "-" : "+"}${Number(etc[2])}`, lang);
  const last = tz.split("/").pop() ?? tz;
  const city =
    CITY_NAMES[last] ?? last.replace(/^St_/, "St. ").replace(/_/g, " ");
  if (lang === "en") return `${city} time`;
  return /^[AEIOUYÀÂÉÈÊÎÔÛ]/i.test(city)
    ? `heure d'${city}`
    : `heure de ${city}`;
}
